// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";  

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD31kFbqxOZ0Qo8_x2pTHD1yI1PgFkOFzs",
  authDomain: "cecbpm-33900.firebaseapp.com",
  projectId: "cecbpm-33900",
  storageBucket: "cecbpm-33900.appspot.com",
  messagingSenderId: "886631643251",
  appId: "1:886631643251:web:7e35bc63caf6d5b19f5206",
  measurementId: "G-1JV2CMRQ2Y",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();
export const db = getFirestore();
export const storage = getStorage();